/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_myteam_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your starting team — unlimited changes before your first race`)
};

const es_f1_myteam_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu equipo inicial — cambios ilimitados antes de tu primera carrera`)
};

const de_f1_myteam_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Startteam — unbegrenzte Änderungen vor deinem ersten Rennen`)
};

const nl_f1_myteam_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je startteam — onbeperkte wijzigingen vóór je eerste race`)
};

const fr_f1_myteam_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre équipe de départ — changements illimités avant votre première course`)
};

const it_f1_myteam_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua squadra iniziale — modifiche illimitate prima della tua prima gara`)
};

const pt_br2_f1_myteam_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu time inicial — mudanças ilimitadas antes da sua primeira corrida`)
};

const pt_f1_myteam_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua equipa inicial — alterações ilimitadas antes da tua primeira corrida`)
};

const ja_f1_myteam_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スターティングチーム — 初レース前は変更無制限`)
};

const zh_f1_myteam_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的初始阵容 — 首场比赛前可无限次调整`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_myteam_first_race = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_myteam_first_race(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_myteam_first_race", locale)
	if (locale === "en") return en_f1_myteam_first_race(inputs)
	if (locale === "es") return es_f1_myteam_first_race(inputs)
	if (locale === "de") return de_f1_myteam_first_race(inputs)
	if (locale === "nl") return nl_f1_myteam_first_race(inputs)
	if (locale === "fr") return fr_f1_myteam_first_race(inputs)
	if (locale === "it") return it_f1_myteam_first_race(inputs)
	if (locale === "pt-BR") return pt_br2_f1_myteam_first_race(inputs)
	if (locale === "pt") return pt_f1_myteam_first_race(inputs)
	if (locale === "ja") return ja_f1_myteam_first_race(inputs)
	return zh_f1_myteam_first_race(inputs)
};